import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";

export const NewsEntryExternalLinkSchema = z.object({
  __typename: z.literal("NewsEntryExternalLink"),
  sys: Sys,
  title: z.string().nullable(),
  linkUrl: z.string().nullable(),
  linkThumbnail: Image.nullable(),
  linkThumbnailEn: Image.nullable(),
});

export const NewsEntryExternalLink = NewsEntryExternalLinkSchema;
export type NewsEntryExternalLink = z.infer<typeof NewsEntryExternalLinkSchema>;

export const NewsEntryExternalLinkFragment = gql`
  fragment NewsEntryExternalLinkFragment on NewsEntryExternalLink {
    sys {
      ...SysFragment
    }
    title
    linkUrl
    linkThumbnail {
      ...ImageFragment
    }
    linkThumbnailEn: linkThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${SysFragment}
  ${ImageFragment}
`;
